module.exports = __webpack_public_path__ + "img/download-page-bg.41a31da8.png";